import { c as classNames } from '../../index-8887fc24.js';
import React__default from 'react';

var styles = {"row":"TableRow_row_97920da1","clickable":"TableRow_clickable_97920da1","focus-visible":"TableRow_focus-visible_97920da1"};

function TableRow(_a) {
    var _b;
    var onClick = _a.onClick, children = _a.children, rowClassName = _a.rowClassName, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave;
    var handleKeyDown = function (e) {
        if (onClick) {
            if (e.key === "Enter") {
                onClick();
            }
        }
    };
    var handleFocus = function () {
        if (onMouseEnter) {
            onMouseEnter();
        }
    };
    var handleBlur = function () {
        if (onMouseLeave) {
            onMouseLeave();
        }
    };
    return (React__default.createElement("tr", { className: classNames(styles.row, (_b = {},
            _b[styles.clickable] = !!onClick,
            _b), rowClassName), onClick: onClick, tabIndex: onClick ? 0 : undefined, onKeyDown: handleKeyDown, onFocus: handleFocus, onBlur: handleBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave }, children));
}

export { TableRow };
